import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
// import shuffle from 'array-shuffle';

import Header from '../Header/Header';
import LoadScreen from '../LoadScreen/LoadScreen';
import OfflineError from '../OfflineError/OfflineError';
//import ReferenceDetail from '../ReferenceDetail/ReferenceDetail';
import ReferenceImageBox from '../ReferenceImageBox/ReferenceImageBox';

//import icons from '../../data/icons';
import * as actions from '../../actions/index';

import './MediaLibrary.css';


const chunk = function(a, l) {
    if (a.length === 0) return []; 
    else return [a.slice(0, l)].concat(chunk(a.slice(l), l)); 
}

const solutions = ['All', 'PowerStore', 'Emax2', 'Services', 'MGS100'];
const contentTypes = ['All', 'Datasheets', 'Presentations', 'Brochures', 'Videos', 'Case Studies'];

const getMenuItems = function(news, currentSolution, currentContentType) {
  news = currentSolution && currentSolution !== solutions[0] ? news.filter(story => story.solutions && story.solutions.indexOf(currentSolution) > -1) : news;
  news = currentContentType && currentContentType !== contentTypes[0] ? news.filter(story => story.contentTypes && story.contentTypes.indexOf(currentContentType) > -1) : news;
  // news = shuffle(news);

  return chunk(news || [], 3);
}

const isLargeBox = function(pos) {
  return (pos % 6 === 0) || (pos % 6 === 1);
}


class MediaLibrary extends React.Component {
  propTypes: {
    data: propTypes.object,
    news: propTypes.array,
    currentNews: propTypes.string,
    currentSolution: propTypes.string,
    currentContentType: propTypes.string,
    error: propTypes.string
  }
  constructor(props) {
    super(props);
    this.handleWheel = this.handleWheel.bind(this);
    this.setScrollWait = this.setScrollWait.bind(this);
    this.goToNextNews = this.goToNextNews.bind(this);
    this.handleSwipe = this.handleSwipe.bind(this);
    this.goToPreviousNews = this.goToPreviousNews.bind(this);
    this.scrollWaiting = false;
  }
  handleSwipe(event) {
    if(this.props.currentNews) {
      if (event.detail && event.detail.direction === 'left' && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToNextNews(this.props.currentNews);
      }
      if (event.detail && event.detail.direction === 'right' && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToPreviousNews(this.props.currentNews);
      }
    }
  }
  handleWheel(event) {
    //TODO: Fix this.
    if(false && false && false && this.props.currentNews) {
      if (event.deltaY > 0 && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToNextNews(this.props.currentNews);
      }
      if (event.deltaY < 0 && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToPreviousNews(this.props.currentNews);
      }
    }
  }
  goToNextNews(currentNews) {
    if(!currentNews) {
      const news = (this.props.news || []);
      (news[0] || {})._id && this.props.goToNews(news[0]._id);
      return;
    }
    let found = false;
    const afters = (this.props.news || []).filter(x => (found || (x._id === currentNews)) && (found = true));
    const goToId = afters && afters[1] && afters[1]._id;
    this.props.goToNews(goToId);//goes back to start if no next
  }
  goToPreviousNews(currentNews) {
    if(!currentNews) {
      const news = (this.props.news || []);
      (news[news.length-1] || {})._id && this.props.goToNews(news[news.length-1]._id);
      return;
    }
    let found = false;
    const befores = !currentNews ? this.props.news : (this.props.news || []).filter(x => !((found || (x._id === currentNews)) && (found = true)));
    const index = befores.length - 1;
    const goToId = befores && befores[index] && befores[index]._id;
    this.props.goToNews(goToId);//goes back to start if no previous
  }
  setScrollWait() {
    this.scrollWaiting = true;
    window.setTimeout(x => this.scrollWaiting = false, 500);
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).addEventListener('onSwipe', this.handleSwipe);
  }
  componentWillUnmount() {
    ReactDOM.findDOMNode(this).removeEventListener('onSwipe', this.handleSwipe);
  }
  // componentWillMount() {
  //   this.props.getNews(this.props.src);
  // }
  render(props) {
    const onClick = (mediaItem) => (this.props.setModal(mediaItem));
    const onClickSolution = (solution) => (this.props.goToSolution((typeof solution === 'string' && solution) || null));
    const onClickContentType = (contentType) => (this.props.goToContentType((typeof contentType === 'string' && contentType) || null));
    return (
      <section className="news receives-swipes" onWheel={this.handleWheel}>
        {this.props.loading && <LoadScreen />}
        {this.props.error && <OfflineError />}
        {
          <section className="news__container">
            <section className="news__categories">
              <Header title="MediaLibrary" />
              <section className="news__filterContainer">
                <h4 className="news__filterHeading">By Solution</h4>
                {solutions.map(solution => (
                  <div className="filter-button-row" key={solution} onClick={x => onClickSolution(solution)}>
                    <a className={"filter-button"+((this.props.currentSolution || solutions[0]) === solution ? ' selected' : '')}>{solution}</a>
                  </div>
                ))}
                <h4 className="news__filterHeading">By Type</h4>
                {contentTypes.map(contentType => (
                  <div className="filter-button-row" key={contentType} onClick={x => onClickContentType(contentType)}>
                    <a className={"filter-button"+((this.props.currentContentType || contentTypes[0]) === contentType ? ' selected' : '')}>{contentType}</a>
                  </div>
                ))}
              </section>
            </section>
            <section className="news__navArea">
              {
                getMenuItems(this.props.data.media, this.props.currentSolution, this.props.currentContentType).map((group, groupNum) => (
                  <section className="news_navGroup" key={"news_navGroup"+groupNum}>
                  { group.map((item, pos) => (
                    <ReferenceImageBox
                      key={item._id || item.id}
                      {...item}
                      isLargeBox={isLargeBox((groupNum * 3) + (pos + 1))}
                      news={this.props.news}
                      onClick={onClick.bind(this, item)}
                    />
                  ))}
                  </section>
                ))
              }
            </section>
          </section>
        }
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    // getNews: (url) => {
    //   dispatch(actions.requestNews(url));
    // },
    goToNews: (newsId) => {
      dispatch(actions.goToNews(newsId));
    },
    goToCategory: (category) => {
      dispatch(actions.goToCategory(category));
    },
    goToSolution: (solution) => {
      //console.log('going to solution', solution);
      dispatch(actions.goToSolution(solution));
    },
    goToContentType: (contentType) => {
      console.log('going to content type', contentType);
      dispatch(actions.goToContentType(contentType));
    },
    setModal: (media) => {
      dispatch(actions.setModal(media));
    }
  };
}

function mapStateToProps(state) {
  return {
    loading: state.news.loading,
    news: state.news.news,
    error: state.news.error,
    currentNews: state.news.currentNews,
    currentSolution: state.news.currentSolution,
    currentContentType: state.news.currentContentType,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MediaLibrary);



// WEBPACK FOOTER //
// ./src/components/MediaLibrary/MediaLibrary.js